<template>
<section class="height100vh">
    <div class="wrap">
        <div class="new_content_box1">
            <h3 class="title"><span>방문예약 정보</span></h3>
            <div class="showroom_reservation_box">
                <div class="showroom_info">
                    <figure><img :src="viewScAttUrl(bookingWrite.scUrl)"></figure>
                    <dl>
                        <dt>{{bookingWrite.scName}} 컨설턴트</dt>
                        <dd>{{bookingWrite.scShopName}}({{bookingWrite.scDealerName}})</dd>
                    </dl>
                </div>
                <div class="my_reservation_info">
                    <div>
                        <dl style="margin-top: 10px;">
                            <dt style="line-height:1.4;">
                                {{bookingWrite.modelName}} {{bookingWrite.trimName}}
                            </dt>
                            <dd>
                                <span>{{bookingDate(bookingWrite.bookingDt)}}</span>
                                <span>{{bookingTime(bookingWrite.bookingDt)}}</span>
                            </dd>
                        </dl>
                        <dl style="margin-top: 20px;">
                            <dt>예약목적</dt>
                            <dd>{{bookingType(bookingWrite.type)}}</dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="new_content_box2">
            <h3 class="title"><span>예약자 정보</span></h3>
            <div class="reservation_input_box">
                <dl>
                    <dt>{{auth.name}}</dt>
                    <dd>{{auth.phone}}</dd>
                </dl>
            </div>
        </div>
        

        <div class="new_content_box2" style="margin-bottom: 20px;">
            <h3 class="title">
                <span>고객차량정보</span>
                <p class="sub">방문시 쾌적한 발렛파킹을 위해 필요한 정보입니다.</p>
            </h3>
            
            <div class="reservation_input_box">
                <ul>
                    <li>
                        <p>보유차종</p>
                        <input type="text" placeholder="보유차종을 입력해주세요." v-model="bookingWrite.userVehicle">
                    </li>
                    <li>
                        <p>차량번호</p>
                        <input type="text" placeholder="차량번호를 입력해주세요." v-model="bookingWrite.userVehicleNum">
                    </li>
                </ul>
            </div>
        </div>
        

        <div style="height:56px;"></div>
    </div>

    <button class="default_fixed_btn" @click="booking()">예약하기</button>
    
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { BookingFormatMixin } from '../../mixins/BookingFormatMixin';

export default {
    name:'BookingInputVehicle',
    mixins:[BookingFormatMixin],
    computed: {
        ...mapState({
            auth: state => state.auth.item,
            bookingWrite: state => state.booking.itemWrite,
        }),
        ...mapGetters([
            'viewScAttUrl'
        ]),
        bookingId(){
            return Number(this.$route.params.bookingId);
        },
    },
    created () {
        this.$store.commit('SHOW_ONLOAD');
    },
    methods: {
        async booking() {
            this.bookingWrite.choice = this.bookingWrite.choice.toString();
            this.bookingWrite.userId = this.auth.id;

            try {

                if(this.bookingId) {
                    this.bookingWrite.id = this.bookingId;
                    await this.$store.dispatch('UPDATE_BOOKING',this.bookingWrite);
                } else {
                    await this.$store.dispatch('CREATE_BOOKING',this.bookingWrite)
                }

                this.$store.commit('OPEN_MODAL', { 
                    content: '예약이 완료되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => {
                        this.$router.push('/main');
                        this.$store.commit('CLEAR_BOOKING_WRITE');
                    }
                });

            } catch (e) {
                this.apiCatch(e);
            }
            
            
        }
    },
}
</script>

<style scoped>

</style>